module.exports = __webpack_public_path__ + "static/img/case_14.3d7a113.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_14.jpg
// module id = rUtx
// module chunks = 0